import { Component } from 'react'
import PropTypes from 'prop-types'
import Link from '../../../Utilities/Link'
import SampleButton from '../../../Utilities/SampleButton'
import RegionalMapShapefileContact from '../RegionalMapShapefileContact'
import ProgrammableLink from '../../../Utilities/ProgrammableLink'
import { Container, H2, H4, Subtitle1, Body1, Share, Button } from '../../../cdl-react-components/components'
import { formatBytes } from '../../../cdl-react-components/utilities/files'
import { formatResultsItemDate } from '../../../../utilities'

class RegionalMapMobile extends Component {
    renderDownloadButton = (regionalMap, authenticated, user) => {
        if (!regionalMap.pdf)
            return null
        else if (new Date(regionalMap.publication_date) > new Date())
            return null
        else if (authenticated)
            return (
                <ProgrammableLink 
                    style={{ width: '100%' }}
                    href={this.props.link}
                    target="_blank" rel="noreferrer"
                    onBeforeRedirect={this.props.logMapOpened}>
                    <Button raised style={{ width: '100%' }}>Download Map</Button>
                </ProgrammableLink>
            )
        else if (regionalMap.sample_pdf)
            return <SampleButton href={this.props.sampleLink} type="CDL Map">Download Sample Map</SampleButton>
        else if (user)
            return <Link className="btn btn--raised" href="/subscribe">Subscribe to Download Map</Link>
        else
            return (
                // <Fragment>
                //     <Link className="btn" href="/subscribe">Subscribe</Link>
                    <Button raised onClick={this.props.handleLogin}>Login to View Map</Button>
                //</Fragment>
            )
    }

    renderContents = regionalMap => {
        return (
            <div className="regional-map__contents">
                <H4>Contents</H4>
                <table>
                    <tbody>
                        <tr>
                            <th>Map&nbsp;type:</th>
                            <td>{regionalMap.map_type && regionalMap.map_type.map(x => x.name).join(', ')}</td>
                        </tr>
                        {regionalMap.pdf && (
                            <tr>
                                <th>File&nbsp;size:</th>
                                <td>{regionalMap.pdf_size_field ? formatBytes(regionalMap.pdf_size_field, 2) : null}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        const { regionalMap, authenticated, user } = this.props

        const description = authenticated ?
            regionalMap.private_description :
            regionalMap.description

        return (
            <div id="regional-map--mobile">
                <div className="regional-map__image">
                    <img alt={regionalMap.title} src={this.props.getImage(regionalMap, authenticated)} />
                </div>
                <Container>
                    <H2>{regionalMap.title}</H2>
                    <Subtitle1>{regionalMap.subtitle}</Subtitle1>
                    <Body1>{formatResultsItemDate(regionalMap)}</Body1>
                    <Body1 dangerouslySetInnerHTML={{ __html: description }} />
                    <div className="flex flex--center">
                        {this.renderDownloadButton(regionalMap, authenticated, user)}
                    </div>
                    <RegionalMapShapefileContact map={regionalMap} />
                    <hr />
                    {this.renderContents(regionalMap)}
                    <hr />                    
                    <Share title={regionalMap.title} url={window.location.origin + window.location.pathname} />
                </Container>
            </div>
        )
    }
}

RegionalMapMobile.propTypes = {
    regionalMap: PropTypes.object.isRequired,
    authenticated: PropTypes.bool.isRequired,
    handleLogin: PropTypes.func.isRequired,
    logMapOpened: PropTypes.func.isRequired,
    user: PropTypes.object,
    link: PropTypes.string,
    sampleLink: PropTypes.string
}

export default RegionalMapMobile